import React from "react";
import { Card, CardHeader } from "../../../components/shadcn-ui/card";
import { ChevronRight } from "lucide-react";
import { Separator } from "../../../components/shadcn-ui/separator";

export const LeadCard: React.FC<{
  firstName: string;
  lastName: string;
  mobileNumber: string;
  emailAddress: string;
  index: number;
  source: { referral: string; channel: string }; //TODO: update referral to referrer
}> = ({ firstName, lastName, mobileNumber, emailAddress }) => {
  return (
    <Card className="shadow-sm flex gap-4 items-center p-2 md:p-1 cursor-pointer rounded-md hover:bg-gray-200 hover:border-white transition-colors duration-300 ease-in-out">
      <span className="flex gap-2 md:gap-1 items-center">
        <img
          className="md:h-8 ml-1 mr-1 rounded-xl"
          src="/assets/user-icon.svg"
          alt="Source Icon"
        />
        <Separator
          orientation="vertical"
          className="w-px h-12 md:h-8"
        ></Separator>
      </span>
      <div className="flex flex-1 gap-0.5 flex-col md:flex-row items-start md:items-center justify-between">
        <div className="flex-1">
          <CardHeader className="p-0 text-lg md:text-sm font-semibold leading-none">
            {firstName} {lastName}
          </CardHeader>
        </div>
        <div className="text-sm sm:block text-gray-800 flex-1 font-normal text-muted-foreground">
          {emailAddress}
        </div>
        <p className="text-sm text-gray-800 flex-1 sm:block text-muted-foreground">
          {mobileNumber}
        </p>
      </div>
      <div className="h-10 w-10 text-gray-500 flex justify-center items-center">
        <ChevronRight className="text-gray-500" />
      </div>
    </Card>
  );
};
